import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "ul-img-box"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { Bridge } from '@/utils/bridge';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import constants, { processUserAgent } from '@/constants';
export default {
  __name: 'ShareBtn',
  props: ['shareConfiguration'],
  emits: ['closeSharePopup'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      IMAGE_URL,
      SHARE_MODULE: {
        MAX_PIC_NUM,
        SHARE_TYPE,
        BTN_TYPE_FUNC,
        IMG_URL
      }
    } = constants;
    const {
      t
    } = useI18n();
    const store = useStore();
    const ulClass = ref('');
    const canvasRef = ref(null);
    const asinImgList = ref();
    const isLoading = ref(false);
    let html2canvas = null;

    // phone bottom security height
    const distanceFromPhoneBottomStatusBar = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.agentData.bottom) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    const getSelectedPicNumber = selectedPic => {
      const num = store.state.share.picListSelected.findIndex(el => el === selectedPic);
      return num >= 0 ? num + 1 : -1;
    };
    const convertImgUrlToBase64Format = (el, url, outputFormat = '') => {
      return new Promise(resolve => {
        const canvas = el;
        setTimeout(() => {
          const ctx = canvas.getContext('2d');
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = url;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL(outputFormat || 'image/jpg');
            resolve(dataURL);
          };
        }, 300);
      });
    };
    const getImgList = () => {
      var _props$shareConfigura, _props$shareConfigura2, _props$shareConfigura3, _props$shareConfigura4;
      const imgList = props.shareConfiguration.asinInfo.imageUrls.map((el, idx) => {
        const imgInfo = {};
        imgInfo.url = el;
        imgInfo.state = idx === 0;
        return imgInfo;
      });
      const imgUrlDefault = (_props$shareConfigura = props.shareConfiguration) !== null && _props$shareConfigura !== void 0 && (_props$shareConfigura2 = _props$shareConfigura.asinInfo) !== null && _props$shareConfigura2 !== void 0 && _props$shareConfigura2.imageUrls.length ? (_props$shareConfigura3 = props.shareConfiguration) === null || _props$shareConfigura3 === void 0 ? void 0 : (_props$shareConfigura4 = _props$shareConfigura3.asinInfo) === null || _props$shareConfigura4 === void 0 ? void 0 : _props$shareConfigura4.imageUrls[0] : '';
      store.commit('share/setPicListSelected', [imgUrlDefault]);
      return imgList;
    };
    const handleImgSelect = item => {
      let list = [];
      const picListSelected = store.state.share.picListSelected;
      if (picListSelected.length >= MAX_PIC_NUM && !picListSelected.includes(item.url)) {
        showToast({
          message: t('modules.share.SELECT_IMAGES_TO_GENERATE_POST_THRESHOLD'),
          className: 'a-toast'
        });
        return;
      }
      item.state = !item.state;
      list = item.state ? [...picListSelected, item.url] : picListSelected.filter(el => el !== item.url);
      store.commit('share/setPicListSelected', list);
    };
    const getShareImgBase64 = () => {
      var _processUserAgent, _processUserAgent$app;
      /**
       * userAgent:appDeviceScreen/44_34_3.0
       * For this example, the below code will get 'Device Pixel Scale' for the scale.
       */
      const scale = ((_processUserAgent = processUserAgent(navigator.userAgent)) === null || _processUserAgent === void 0 ? void 0 : (_processUserAgent$app = _processUserAgent.appDeviceScreen) === null || _processUserAgent$app === void 0 ? void 0 : _processUserAgent$app.split('_')[2]) || 1.0;
      return new Promise(resolve => {
        const dom = document.querySelector('#poster-share');
        setTimeout(() => {
          html2canvas(dom, {
            useCORS: true,
            scale,
            width: dom.clientWidth,
            height: dom.scrollHeight,
            allowTaint: true
          }).then(canvas => {
            const imgUrl = canvas.toDataURL();
            resolve(imgUrl);
          });
        }, 300);
      });
    };
    const BTN_TYPE = [{
      icon: IMG_URL.WECHAT_URL,
      text: t('modules.share.WECHAT_FRIENDS'),
      eventName: BTN_TYPE_FUNC.shareWechat
    }, {
      icon: IMG_URL.GENERATE_IMAGES_URL,
      text: t('modules.share.GENERATE_IMAGES'),
      eventName: BTN_TYPE_FUNC.generateImages
    }, {
      icon: IMG_URL.SAVE_IMAGES_URL,
      text: t('modules.share.SAVE_PICTURE'),
      eventName: BTN_TYPE_FUNC.saveImages
    }];
    const handleCloseSharePoopup = () => {
      emit('closeSharePopup');
    };
    const handleShareWeChat = async () => {
      const {
        result: hasWeChat
      } = await Bridge.callFnVal('checkWeChatAppHasInstalled');
      if (!hasWeChat) {
        showToast({
          message: t('modules.share.WECHAT_IS_NOT_INSTALLED'),
          className: 'a-toast'
        });
        return;
      }
      const imgUrl = props.shareConfiguration.asinInfo.imageUrls[0] || `${IMAGE_URL}assets/image/emptyList.png`;
      const thumbImageBase64 = await convertImgUrlToBase64Format(canvasRef.value, imgUrl, 'image/png');
      // call shareData func from native
      await Bridge.callFn('shareData', {
        platform: store.state.share.platform,
        type: SHARE_TYPE.shareLink,
        data: {
          url: props.shareConfiguration.shareUrl,
          title: props.shareConfiguration.asinInfo.title,
          description: t('modules.share.WECHAT_SHARE_TITLE'),
          thumbImageBase64
        }
      });
      handleCloseSharePoopup();
    };
    const handleGenerateImages = () => {
      const imageUrls = props.shareConfiguration.asinInfo.imageUrls;
      const picListSelected = imageUrls.length ? [imageUrls[0]] : [];
      store.commit('share/setPicListSelected', picListSelected);
      store.commit('share/setShareBtn', [BTN_TYPE[0], BTN_TYPE[2]]);
      store.commit('share/setIsShowPoster', true);
    };
    const handleSaveImages = async () => {
      isLoading.value = true;
      const imageBase64 = await getShareImgBase64();
      const {
        result
      } = await Bridge.callFnVal('saveImageToAlbum', {
        imageBase64
      });
      isLoading.value = false;
      if (!result) return;
      showToast({
        message: t('modules.share.GENERATE_IMAGES_SUCCEED'),
        className: 'a-toast'
      });
      handleCloseSharePoopup();
    };
    const handleBtn = async type => {
      switch (type) {
        case BTN_TYPE_FUNC.shareWechat:
          await handleShareWeChat();
          break;
        case BTN_TYPE_FUNC.generateImages:
          handleGenerateImages();
          break;
        case BTN_TYPE_FUNC.saveImages:
          await handleSaveImages();
          break;
        default:
          await handleShareWeChat();
          break;
      }
    };
    onMounted(() => {
      var _props$shareConfigura5;
      if (((_props$shareConfigura5 = props.shareConfiguration) === null || _props$shareConfigura5 === void 0 ? void 0 : _props$shareConfigura5.type) === SHARE_TYPE.shareLink) {
        store.commit('share/setShareBtn', [BTN_TYPE[0]]);
        ulClass.value = 'ulBtn';
      } else {
        store.commit('share/setShareBtn', [BTN_TYPE[0], BTN_TYPE[1]]);
      }
      import('html2canvas').then(plugin => {
        html2canvas = plugin['default'];
      });
      asinImgList.value = getImgList();
    });
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "container-share",
        style: _normalizeStyle({
          paddingBottom: `${distanceFromPhoneBottomStatusBar.value}px`
        })
      }, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        style: {
          "display": "none"
        }
      }, null, 512), _unref(store).state.share.isShowPoster ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asinImgList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [getSelectedPicNumber(item.url) !== -1 ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(getSelectedPicNumber(item.url)), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
          src: item.url,
          class: _normalizeClass(["img-border", {
            'img-no-border': !item.state
          }]),
          onClick: $event => handleImgSelect(item)
        }, null, 10, _hoisted_3)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("ul", {
        class: _normalizeClass([ulClass.value, "ul-btn-box"])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.share.shareBtn.btnList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: $event => handleBtn(item.eventName)
        }, [_createElementVNode("img", {
          src: item.icon
        }, null, 8, _hoisted_5), _createElementVNode("p", null, _toDisplayString(item.text), 1)], 8, _hoisted_4);
      }), 128))], 2), _createElementVNode("div", {
        class: "btn-cancel",
        onClick: handleCloseSharePoopup
      }, _toDisplayString(_ctx.$t('modules.share.CANCEL_ACTION')), 1)], 4)), [[_directive_loading, isLoading.value]]);
    };
  }
};